import { combineReducers } from "redux";

import { applicationLayoutReducer } from "./applicationLayout/reducer";
import { fileReducer } from "./fileParsing/reducer";
import { dataReducer } from "./data/reducer";
import { optionsReducer } from "./options/reducer";
import { languageReducer } from "./language/reducer";
import { filterReducer } from "./filters/reducer";
import { wranglerReducer } from "./wrangler/reducer";

export const rootReducer = combineReducers({
  applicationLayout: applicationLayoutReducer,
  filters: filterReducer,
  fileParsing: fileReducer,
  language: languageReducer,
  options: optionsReducer,
  wrangler: wranglerReducer,
  data: dataReducer,
});

export type ApplicationState = ReturnType<typeof rootReducer>;
